<mat-form-field appearance="outline"
                subscriptSizing="dynamic"
                class="mat-form-field-sm">
  <mat-select [ngModel]="currentEntityId"
              (selectionChange)="changeEntity($event.value)">
    <ng-container *ngFor="let entity of entities">
      <mat-option [value]="entity?.id">
        {{ entity.dba || entity.name }}
      </mat-option>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-select>
</mat-form-field>
